import CryptoJS from "crypto-js"
import {seckret_key} from "./seckret_key";

function encryptJSON(jsonData, secretKey=seckret_key) {
    // Преобразовываем JSON в строку
    const jsonString = JSON.stringify(jsonData);
    // Шифруем строку с использованием AES и секретного ключа
    const encrypted = CryptoJS.AES.encrypt(jsonString, secretKey).toString();
    //console.log(encrypted)
    return encrypted;
}
export default encryptJSON;